import apiConfig from 'src/integration/config/apiConfig';
import useQueryKey from 'src/toolkit/utils/useQueryKey';
import { useStore } from 'src/integration/store/store';
import useReactQueryJava from 'src/integration/api/useReactQueryJava';
import { MIN_15 } from 'src/integration/config/constants';
import useErrorHandling from 'src/toolkit/utils/useErrorHandling';

const useFetchChartSocAndBalancing = () => {
  const { socAndBalancingStore, settingsStore } = useStore();
  const { setSocAndBalancingData } = socAndBalancingStore;
  const { selectedSiteId, selectedDate } = settingsStore;
  const { logoutOnError } = useErrorHandling();

  const response = useReactQueryJava<SimpleObject, SimpleObject>({
    endpoint: apiConfig.api.endpointsJava.socAndBalancing,
    queryKey: useQueryKey('socAndBalancing', [selectedDate, selectedSiteId?.toString()]),
    method: 'GET',
    queryParams: {
      date: selectedDate,
      siteId: selectedSiteId,
    },
    opts: {
      enabled: !!selectedSiteId,
      refetchOnWindowFocus: false,
      refetchInterval: MIN_15,
      onSuccess: (data: any[]) => {
        setSocAndBalancingData(data);
      },
    },
  });

  return {
    ...response,
  };
};

export default useFetchChartSocAndBalancing;
